import React from "react";

// Pure-CSS seamless marquee. `items` = array of strings.
export default function Marquee({ items = [], className = "", speed = 30, accent = false }) {
  const content = [...items, ...items];
  return (
    <div className={`relative flex overflow-hidden ${className}`} data-testid="marquee">
      <div
        className="flex shrink-0 items-center whitespace-nowrap"
        style={{ animation: `marquee ${speed}s linear infinite` }}
      >
        {content.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-display uppercase">
            <span className={accent && i % 2 ? "text-stroke-accent" : "text-stroke"}>{t}</span>
            <span className="text-vorna-accent text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
